var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-PageActions"
  }, [_c('polaris-stack', {
    attrs: {
      "spacing": "tight",
      "distribution": _vm.secondaryActions.length > 0 ? 'equalSpacing' : 'trailing'
    }
  }, [(_vm.secondaryActions.length > 0) ? _c('polaris-stack-item', [_c('polaris-button-group', _vm._l((_vm.secondaryActions), function(action, index) {
    return _c('polaris-button', {
      key: "action",
      attrs: {
        "accessibility-label": action.accessibilityLabel,
        "url": action.url,
        "disabled": action.disabled,
        "destructive": action.destructive
      },
      on: {
        "click": function($event) {
          _vm.handleAction(action)
        }
      },
      slot: index
    }, [_vm._v("\n                    " + _vm._s(action.content) + "\n                ")])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.primaryAction) ? _c('polaris-stack-item', [_c('polaris-button', {
    attrs: {
      "accessibility-label": _vm.primaryAction.accessibilityLabel,
      "url": _vm.primaryAction.url,
      "disabled": _vm.primaryAction.disabled,
      "destructive": _vm.primaryAction.destructive,
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.primaryAction)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryAction.content) + "\n            ")])], 1) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bec645f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bec645f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPageActions.vue
// module id = 220
// module chunks = 0